<breadcrumb [breadcrumbList]="breadcrumbList"></breadcrumb>
<div class="card">
	<div class="card-header bg-theme">
		<h5 class="card-title pt-1 text-light mb-0">
			{{pagetitle}}
		</h5>
	</div>
	<div class="card-body">
		<div class="row g-1">
			@for (item of statusList; track $index) {
			<div class="col-3 call-data" (click)="selectType(item.val)">
				<div class="card">
					<div class="card-body p-2" [ngClass]="getSelectedClass(item.val)"
						[ngStyle]="{'background-color':item.color}">
						<h4>
							<img [src]="'../assets/img/'+item.img1" class="call-image" alt="Call Image" />
							{{item.name}}
						</h4>
						<h3>
							{{call_counts[item.count_key]}}
						</h3>
					</div>
				</div>
			</div>
			}
		</div>
		<div class="table-responsive">
			<table datatable [dtOptions]="dtOptions" class="table table-striped table-bordered table-hover"
				style="width: 100%;">
				<thead>
					<tr class="table_head">
						<th style="width: 5%;"></th>
						<th style="width: 25%;">From</th>
						<th style="width: 25%;">To</th>
						<th style="width: 15%;">Date Time</th>
						<th style="width: 25%;">Results</th>
						<th style="width: 5%;">Action</th>
					</tr>
				</thead>
				<tbody *ngIf="dataList?.length != 0">
					<tr *ngFor="let data of dataList;let i = index;">
						<td>
							<img [src]="'../assets/img/'+getIcon(data.call_type)"
								matTooltip="{{getType(data.call_type)}}" class="call-image" alt="Call Image" />
						</td>
						<td>
							@if(data.call_type=='outgoing'){
							{{ data.answered_agent_name }}
							({{ data.answered_agent_number }})
							}@else if(
							data.call_type=='call_answered_by_agent' ||
							data.call_type=='call_missed_by_agent'
							){
							{{ data.caller_id_number }}
							}
						</td>
						<td>
							@if(data.call_type=='outgoing'){
							{{ data.call_to_number }}
							}@else if(data.call_type=='call_answered_by_agent'){
							{{ data.answered_agent_name }}
							({{ data.answered_agent_number }})
							}@else if(data.call_type=='call_missed_by_agent'){
							@if(data.missed_agent){
							@for (item of data.missed_agent; track $index) {
							{{ item?.name }}
							({{ item?.agent_number || item?.number }})
							}
							}@else{
							{{ data.call_to_number }}
							}
							}
						</td>
						<td>
							{{ formatDateTime(data.start_stamp) }}
						</td>
						<td>
							{{data.hangup_cause}}
						</td>
						<td>
							<a *ngIf="data.recording_url" href="{{data.recording_url}}" class="btn btn-xs btn-info"
								target="_blank" matTooltip="Recording">
								<fa-icon [icon]="['fas','microphone']"></fa-icon>
							</a>
						</td>
					</tr>
				</tbody>
				<tbody *ngIf="dataList?.length == 0">
					<tr>
						<td colspan="6" class="text-center">No data found!</td>
					</tr>
				</tbody>
			</table>
		</div>
	</div>
</div>